module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2"
    }
  }, [_vm._v("THE BATTLES OF EL ALAMEIN")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_1"
    }
  }, [_vm._v("Setting the Scene: Key Commanders of El Alamein; the Principal Cast")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_2"
    }
  }, [_vm._v("The Supporting Cast – Order of Battle (ORBAT) as of 23 October 1942")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_3"
    }
  }, [_vm._v("Prelude: The Battles of Gazala and Mersa Matruh")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_4"
    }
  }, [_vm._v("Act One: The First Battle of El Alamein: A Line in the Sand")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_5"
    }
  }, [_vm._v("Interlude – Taking Stock and the Battle of Alam Halfa")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_6"
    }
  }, [_vm._v("Act Two, Scene One: The Second Battle of El Alamein: Operation Lightfoot")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_7"
    }
  }, [_vm._v("Act Two, Scene Two: Dogfight: The Inferno Continues")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_8"
    }
  }, [_vm._v("Act Two, Scene Three: Supercharge: Let Slip the Dogs of War")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter2#h3_9"
    }
  }, [_vm._v("Endings")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("QUARTERMASTER’S SECTION")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter3#intro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter3#h3_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crusader Tank")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter3#h3_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Panzer III ausf L")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter3#h3_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Messerschmitt Bf 109 E-4/N Trop")])]), _vm._v(" "), _c('h3', {
    staticClass: "tocch1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter3#h3_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curtiss P-40")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0